export default __webpack_public_path__ + "static/media/Boots of Rapturous Battle.0fd89c82.jpg";